var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardArrowDownOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7018 14.2982L7.70175 9.29825C7.52632 9.10526 7.2807 9 7 9C6.45614 9 6 9.45614 6 10C6 10.2807 6.10526 10.5263 6.29825 10.7018L11.2982 15.7018C11.4737 15.8947 11.7193 16 12 16C12.5439 16 13 15.5439 13 15C13 14.7193 12.8947 14.4737 12.7018 14.2982ZM16.2982 9.29825L11.2982 14.2982C11.1053 14.4737 11 14.7193 11 15C11 15.5439 11.4561 16 12 16C12.2807 16 12.5263 15.8947 12.7018 15.7018L17.7018 10.7018C17.8947 10.5263 18 10.2807 18 10C18 9.45614 17.5439 9 17 9C16.7193 9 16.4737 9.10526 16.2982 9.29825Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDownOutlined);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down_outlined.b0000719.svg";
export { ForwardRef as ReactComponent };